<script setup lang="ts"></script>

<template>
  <div class="inform">
    <div class="inform__title-wrapper">
      <VIcon
        class="inform__title-wrapper__icon"
        icon="f7-exclamationmark-circle"
        size="20"
      />
      <div class="inform__title-wrapper__title">꼭 알아 두세요</div>
    </div>
    <!-- 아래는 for문 -->
    <div class="mt-4">
      <div class="inform__content"><b>‧</b> 봉사내용: 봉사활동에 대한 문의사항을 작성해주세요.</div>
      <div class="inform__content"><b>‧</b> 신청결과: 봉사신청에 대한 문의사항을 작성해주세요.</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.inform {
  width: 100%;
  background-color: #fafafa;
  padding: 25px 10px;
  &__title-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    &__icon {
      color: #a9a9a9;
      margin-right: 5px;
    }
    &__title {
      color: #a9a9a9;
      font-weight: 800;
    }
  }
  &__content {
    color: #a9a9a9;
  }
}
</style>
